import { useDispatch } from 'react-redux';
import {
    showSnackbar as showSnackbarAction,
    hideSnackbar as hideSnackbarAction,
} from './actions';

export const useSnackbar = () => {
    const dispatch = useDispatch();

    const hideSnackbar = (id) => {
        dispatch(hideSnackbarAction(id));
    };

    const showSnackbar = ({ id, message, action, anchorOrigin, customization = {} }) => {
        dispatch(showSnackbarAction({
            id,
            snackbarProps: {
                key: id,
                message,
                action,
                anchorOrigin,
                customization,
            },
        }));
    };

    return [showSnackbar, hideSnackbar];
};
